import React, { useState, useEffect, useCallback, use, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DevisList.css';
//import InvoiceForm from '../InvoiceFormx';
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Spinner } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaCashRegister, FaCheckCircle, FaEdit, FaEllipsisH, FaFilePdf, FaFilter, FaInfo, FaPlus, FaSearch, FaTrash } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import DevisForm from './DevisForm';
import { devisActions } from '../../sagas/devisSlice';
import { useNavigate } from 'react-router-dom';
import { formatPrice, convertNumberToWords } from '../../helpers/utility';

import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { commandeActions } from '../../sagas/commandeSlice';
import BCForm from './BCForm';
import { productActions } from '../../sagas/productSlice';
import { debounce } from 'lodash';
import { clientActions } from '../../sagas/clientSlice';
import Select from "react-select";

const BonCommandeList = () => {
    const dispatch = useDispatch();
    const list = useSelector((state) => state.commande.list);
    const loading = useSelector((state) => state.commande.loading);
    const [filter, setFilter] = useState('');
    const { company } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [selectedCommande, setSelectedCommande] = useState(null);
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const searchInputRef = useRef(null);
    const clients = useSelector(state => state.clients.clients);
    const [selectedClient, setSelectedClient] = useState(null);

    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: ''
    });

    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(commandeActions.list(payload));
        dispatch(productActions.findAllUnites());

    }, []);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);


    useEffect(() => {
        dispatch(commandeActions.list({
            ...filters,
        }));
    }, [filters]);


    const handleGeneratePdf = (bonCommande) => {
        // First, ask the user whether they want to generate the PDF with TTC or HT prices
        Swal.fire({
            title: t('commande.pdfPriceOption', 'Prix à afficher'),
            text: t('commande.pdfPriceOptionText', 'Choisissez le type de prix à afficher dans le PDF'),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('commande.prixTTC', 'Prix TTC'),
            cancelButtonText: t('commande.prixHT', 'Prix HT'),
            showCloseButton: true,
            closeButtonHtml: '&times;',
        }).then((result) => {
            // If user closes the dialog without choosing, don't generate PDF
            if (result.dismiss === Swal.DismissReason.close) {
                return;
            }

            // Determine if we should show TTC prices (confirmed) or HT prices (canceled)
            const showTTCPrices = result.isConfirmed;

            console.log(bonCommande);
            // Create a wrapper function for convertNumberToWords to add the currency suffix
            const convertAmountToWords = (amount) => {
                const words = convertNumberToWords(Math.round(amount));
                return `${words} dirhams`;
            };

            // Create PDF with slightly larger page format for better layout
            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            // Set document properties
            doc.setProperties({
                title: `Bon de Commande ${bonCommande.numero}`,
                subject: 'Bon de Commande',
                author: 'MatjarPOS',
                creator: 'MatjarPOS System'
            });

            // Get page dimensions
            const pageWidth = doc.internal.pageSize.width;
            const pageHeight = doc.internal.pageSize.height;
            const margin = 15;
            const footerHeight = 20;
            const headerHeight = 40;

            // Extract client information
            const clientName = bonCommande.clientNom;
            const clientContact = [
                bonCommande.clientTelephone1,
                bonCommande.clientEmail,
            ].filter(Boolean).join(", ");

            // Use actual company data from the Redux store if available
            const companyData = {
                name: company?.name || "Ma Société",
                subtitle: company?.subtitle || "Votre partenaire de confiance",
                address: company?.address || "123 Rue Exemple, Ville",
                phone1: company?.phone1 || "0123456789",
                phone2: company?.phone2 || "0987654321",
                email: company?.email || "contact@masociete.com",
                cnss: company?.cnss || "123456789",
                ice: company?.ice || "123456789",
                rc: company?.rc || "123456789",
                if: company?.identificationFiscale || "123456789",
                logo: company?.logo || null,
                website: company?.website || "www.masociete.com",
            };

            // Function to add header to each page
            const addHeader = (doc, isFirstPage = false) => {
                // Add modern header with gradient
                doc.setFillColor(52, 73, 94); // Dark blue for Bon Commande (different from Devis)
                doc.rect(0, 0, pageWidth, isFirstPage ? headerHeight : 20, 'F');
                doc.setFillColor(44, 62, 80); // Darker blue for gradient effect
                doc.rect(0, 0, pageWidth, 5, 'F');

                // Add logo if available and it's the first page
                if (isFirstPage && companyData.logo) {
                    try {
                        doc.addImage(companyData.logo, 'JPEG', margin, 10, 40, 20);
                    } catch (e) {
                        console.error("Error adding logo to PDF", e);
                    }
                }

                // Add company name and subtitle with improved styling
                doc.setTextColor(255, 255, 255);

                if (isFirstPage) {
                    doc.setFontSize(22);
                    doc.setFont('helvetica', 'bold');
                    doc.text(companyData.name, pageWidth / 2, 18, { align: 'center' });
                    doc.setFontSize(12);
                    doc.setFont('helvetica', 'normal');
                    // Split subtitle into multiple lines if needed
                    const subtitleMaxWidth = pageWidth - (margin * 2); // Use margins to determine max width
                    const wrappedSubtitle = doc.splitTextToSize(companyData.subtitle, subtitleMaxWidth);
                    doc.text(wrappedSubtitle, pageWidth / 2, 25, { align: 'center' });

                    // Add company contact info in header
                    doc.setFontSize(8);
                    doc.text(`${companyData.address} | Tél: ${companyData.phone1} | Email: ${companyData.email}`, pageWidth / 2, 35, { align: 'center' });
                } else {
                    // Simplified header for continuation pages
                    doc.setFontSize(12);
                    doc.setFont('helvetica', 'bold');
                    doc.text(`DEVIS N° ${bonCommande.numero} (Suite)`, pageWidth / 2, 12, { align: 'center' });
                }
            };

            // Function to add footer to each page
            const addFooter = (doc) => {
                // Add footer with modern design
                doc.setFillColor(52, 73, 94); // Dark blue to match header
                doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, 'F');

                doc.setFontSize(9);
                doc.setTextColor(255, 255, 255);
                doc.setFont('helvetica', 'normal');
                doc.text(companyData.name, pageWidth / 2, pageHeight - 14, { align: 'center' });
                doc.setFontSize(7);
                doc.text(`${companyData.address} | Tél: ${companyData.phone1} | Email: ${companyData.email} | ICE: ${companyData.ice}`, pageWidth / 2, pageHeight - 9, { align: 'center' });
                doc.text(`RC: ${companyData.rc} | IF: ${companyData.if} | CNSS: ${companyData.cnss} | ${companyData.website}`, pageWidth / 2, pageHeight - 4, { align: 'center' });

                // Add page number
                doc.setFontSize(8);
                doc.setTextColor(255, 255, 255);
                doc.text(`Page ${doc.internal.getNumberOfPages()}`, pageWidth / 2, pageHeight - 20, { align: 'center' });
            };

            // Add first page header
            addHeader(doc, true);

            // Add document title with elegant styling
            doc.setFillColor(240, 240, 240);
            doc.roundedRect(margin, 45, pageWidth - (2 * margin), 12, 2, 2, 'F');
            doc.setTextColor(52, 73, 94); // Dark blue to match header
            doc.setFontSize(14);
            doc.setFont('helvetica', 'bold');
            doc.text(`BON DE COMMANDE N° ${bonCommande.numero}`, pageWidth / 2, 53, { align: 'center' });

            // Format date with better styling
            const formattedDate = new Date(bonCommande.dateCreation).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            // Add Information blocks with improved card-like styling
            // Client Information Card
            doc.setFillColor(248, 249, 250);
            doc.roundedRect(margin, 65, (pageWidth - (3 * margin)) / 2, 40, 2, 2, 'F');
            doc.setDrawColor(220, 220, 220);
            doc.roundedRect(margin, 65, (pageWidth - (3 * margin)) / 2, 40, 2, 2, 'S');

            // Client Information Header
            doc.setFillColor(52, 73, 94); // Dark blue to match header
            doc.roundedRect(margin, 65, (pageWidth - (3 * margin)) / 2, 8, 2, 2, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.text("DESTINATAIRE", margin + ((pageWidth - (3 * margin)) / 4), 70.5, { align: 'center' });

            // Client Information Content
            doc.setTextColor(60, 60, 60);
            doc.setFontSize(9);
            doc.setFont('helvetica', 'bold');
            doc.text(clientName, margin + 5, 78);
            doc.setFont('helvetica', 'normal');
            doc.text(`Adresse: ${bonCommande.clienAdresse || "N/A"}`, margin + 5, 83);
            doc.text(`Contact: ${clientContact}`, margin + 5, 88);
            doc.text(`ICE: ${bonCommande.clientIce || "N/A"}`, margin + 5, 93);

            // Add chantier information if available
            if (bonCommande.chantierNom) {
                doc.setFont('helvetica', 'bold');
                doc.text(`Chantier: ${bonCommande.chantierNom}`, margin + 5, 98);
            }

            // Bon Commande Information Card
            const rightColumnX = margin * 2 + (pageWidth - (3 * margin)) / 2;
            doc.setFillColor(248, 249, 250);
            doc.roundedRect(rightColumnX, 65, (pageWidth - (3 * margin)) / 2, 40, 2, 2, 'F');
            doc.setDrawColor(220, 220, 220);
            doc.roundedRect(rightColumnX, 65, (pageWidth - (3 * margin)) / 2, 40, 2, 2, 'S');

            // Bon Commande Information Header
            doc.setFillColor(52, 73, 94); // Dark blue to match header
            doc.roundedRect(rightColumnX, 65, (pageWidth - (3 * margin)) / 2, 8, 2, 2, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.text("INFORMATION COMMANDE", rightColumnX + ((pageWidth - (3 * margin)) / 4), 70.5, { align: 'center' });

            // Bon Commande Information Content
            doc.setTextColor(60, 60, 60);
            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');
            doc.text(`Numéro: ${bonCommande.numero}`, rightColumnX + 5, 78);
            doc.text(`Date: ${formattedDate}`, rightColumnX + 5, 83);
            doc.text(`Référence: ${bonCommande.devisNumero || "N/A"}`, rightColumnX + 5, 88);

            // Add delivery date if available
            if (bonCommande.dateLivraisonPrevue) {
                const formattedDeliveryDate = new Date(bonCommande.dateLivraisonPrevue).toLocaleDateString('fr-FR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                doc.text(`Livraison prévue: ${formattedDeliveryDate}`, rightColumnX + 5, 93);
            }

            // Start table at a lower Y position
            const tableStartY = 110;

            // Add table for items with improved styling - Modify based on user choice
            const tableData = bonCommande.lignes.map((ligne) => {
                if (showTTCPrices) {
                    // Show TTC prices
                    return [
                        ligne.articleCode,
                        ligne.articleNom,
                        ligne.quantite,
                        unites.find(u => u.code === ligne.unite)?.libelle,
                        `${(ligne.prixUnitaireTTC).toFixed(2)}`,
                        `${(ligne.montantTTC).toFixed(2)}`,
                    ];
                } else {
                    // Show HT prices
                    return [
                        ligne.articleCode,
                        ligne.articleNom,
                        ligne.quantite,
                        unites.find(u => u.code === ligne.unite)?.libelle,
                        `${(ligne.prixUnitaireTTC / (1 + ligne.tauxTVA)).toFixed(2)}`,
                        `${(ligne.montantHT).toFixed(2)}`,
                    ];
                }
            });

            // Determine if this is a small bon commande (few lines)
            const isSmallBonCommande = bonCommande.lignes.length <= 10;

            // Add the table with automatic pagination
            autoTable(doc, {
                startY: tableStartY,
                head: [["Code", "Description", "Qté", "UM", showTTCPrices ? "PU TTC" : "PU HT", showTTCPrices ? "Total TTC" : "Total HT"]],
                body: tableData,
                styles: {
                    fontSize: 9,
                    cellPadding: 3, // Reduced padding from 4 to 3
                },
                headStyles: {
                    fillColor: [52, 73, 94],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                    halign: 'center',
                },
                columnStyles: {
                    0: { halign: 'center', cellWidth: 25 },
                    1: { halign: 'center', cellWidth: 60 },
                    2: { halign: 'center', cellWidth: 20 },
                    3: { halign: 'center', cellWidth: 20 },
                    4: { halign: 'center', cellWidth: 25 },
                    5: { halign: 'center', cellWidth: 25 },
                },
                alternateRowStyles: {
                    fillColor: [245, 245, 245],
                },
                margin: { top: tableStartY, right: margin, bottom: 30, left: margin },
                didDrawPage: (data) => {
                    // Add header and footer on each page
                    if (data.pageNumber > 1) {
                        addHeader(doc, false);
                    }
                    addFooter(doc);
                },
            });

            // Get the Y position after the table
            let currentY = doc.lastAutoTable.finalY + 5; // Reduced spacing from 10 to 5

            // Calculate totals with rounding - Use appropriate totals based on user choice
            const totalHT = (bonCommande.montantTotalTTC - bonCommande.montantTotalTaxe).toFixed(2);
            const tva = (bonCommande.montantTotalTaxe).toFixed(2);
            const totalTTC = (bonCommande.montantTotalTTC).toFixed(2);

            // Reduced space requirements for small bon commande
            const spaceNeeded = isSmallBonCommande ? 80 : 120;

            // Only add a new page if absolutely necessary
            if (currentY + spaceNeeded > pageHeight - footerHeight - 10) {
                doc.addPage();
                addHeader(doc, false);
                addFooter(doc);
                currentY = 30; // Reset Y position on new page
            }

            // Create a modern summary box
            const summaryHeight = isSmallBonCommande ? 34 : 38;
            doc.setFillColor(248, 249, 250);
            doc.roundedRect(rightColumnX, currentY, (pageWidth - (3 * margin)) / 2, summaryHeight, 2, 2, 'F');
            doc.setDrawColor(220, 220, 220);
            doc.roundedRect(rightColumnX, currentY, (pageWidth - (3 * margin)) / 2, summaryHeight, 2, 2, 'S');

            // Add summary lines
            doc.setFontSize(9);
            doc.setTextColor(60, 60, 60);
            doc.setFont('helvetica', 'normal');

            // Summary rows with alternating background
            const rowHeight = isSmallBonCommande ? 10 : 12;
            doc.setFillColor(240, 240, 240);
            doc.rect(rightColumnX, currentY, (pageWidth - (3 * margin)) / 2, rowHeight, 'F');
            doc.text("Total HT:", rightColumnX + 5, currentY + (rowHeight * 0.7));
            doc.setFont('helvetica', 'bold');
            doc.text(`${totalHT} DH`, rightColumnX + (pageWidth - (3 * margin)) / 2 - 5, currentY + (rowHeight * 0.7), { align: 'right' });

            doc.setFont('helvetica', 'normal');
            doc.text("Total TVA (20%):", rightColumnX + 5, currentY + rowHeight + (rowHeight * 0.7));
            doc.setFont('helvetica', 'bold');
            doc.text(`${tva} DH`, rightColumnX + (pageWidth - (3 * margin)) / 2 - 5, currentY + rowHeight + (rowHeight * 0.7), { align: 'right' });

            // Total row with highlight
            const totalRowHeight = isSmallBonCommande ? 12 : 14;
            doc.setFillColor(52, 73, 94); // Dark blue to match header
            doc.rect(rightColumnX, currentY + (rowHeight * 2), (pageWidth - (3 * margin)) / 2, totalRowHeight, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFont('helvetica', 'bold');
            doc.text("TOTAL TTC:", rightColumnX + 5, currentY + (rowHeight * 2) + (totalRowHeight * 0.7));
            doc.text(`${totalTTC} DH`, rightColumnX + (pageWidth - (3 * margin)) / 2 - 5, currentY + (rowHeight * 2) + (totalRowHeight * 0.7), { align: 'right' });

            // Add amount in words with better styling
            // Use the appropriate total based on user choice
            const amountForWords = showTTCPrices ? totalTTC : totalHT;
            const totalInWords = convertAmountToWords(amountForWords);
            const wordsBoxHeight = isSmallBonCommande ? 25 : 30;
            doc.setFillColor(245, 245, 245);
            doc.roundedRect(margin, currentY, (pageWidth - (3 * margin)) / 2, wordsBoxHeight, 2, 2, 'F');
            doc.setDrawColor(220, 220, 220);
            doc.roundedRect(margin, currentY, (pageWidth - (3 * margin)) / 2, wordsBoxHeight, 2, 2, 'S');

            doc.setTextColor(52, 73, 94); // Dark blue to match header
            doc.setFontSize(9);
            doc.setFont('helvetica', 'bold');
            doc.text(`Arrêté le présent bon de commande à la somme de (${showTTCPrices ? 'TTC' : 'HT'}):`, margin + 5, currentY + 8);
            doc.setTextColor(60, 60, 60);
            doc.setFont('helvetica', 'italic');

            // Split long text into multiple lines if needed
            const maxWidth = (pageWidth - (3 * margin)) / 2 - 10;
            const splitText = doc.splitTextToSize(totalInWords, maxWidth);
            doc.text(splitText, margin + 5, currentY + 16);

            // Update current Y position after the totals section
            currentY += isSmallBonCommande ? 35 : 40;

            // Add delivery information section (specific to Bon Commande)
            doc.setFillColor(245, 245, 245);
            doc.roundedRect(margin, currentY, pageWidth - (2 * margin), 25, 2, 2, 'F');
            doc.setDrawColor(220, 220, 220);
            doc.roundedRect(margin, currentY, pageWidth - (2 * margin), 25, 2, 2, 'S');

            // Add delivery info header
            doc.setFillColor(52, 73, 94); // Dark blue to match header
            doc.roundedRect(margin, currentY, pageWidth - (2 * margin), 8, 2, 2, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.text("INFORMATIONS DE LIVRAISON", pageWidth / 2, currentY + 5.5, { align: 'center' });

            // Add delivery info content
            doc.setTextColor(60, 60, 60);
            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');

            // Format delivery date if available
            let deliveryInfo = "Date de livraison: ";
            if (bonCommande.dateLivraisonPrevue) {
                const formattedDeliveryDate = new Date(bonCommande.dateLivraisonPrevue).toLocaleDateString('fr-FR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                deliveryInfo += formattedDeliveryDate;
            } else {
                deliveryInfo += "À convenir";
            }

            doc.text(deliveryInfo, margin + 5, currentY + 15);

            // Add delivery address
            const deliveryAddress = bonCommande.adresseLivraison || bonCommande.clientAdresse || "Adresse du client";
            doc.text(`Adresse de livraison: ${deliveryAddress}`, margin + 5, currentY + 20);

            // Update current Y position after delivery info
            currentY += 30;

            // Add terms and conditions - Condensed for small bon commande
            doc.setFontSize(9);
            doc.setTextColor(80, 80, 80);
            doc.setFont('helvetica', 'normal');
            doc.text("Conditions et modalités:", margin, currentY);
            doc.setFontSize(8);

            // Reduced line spacing for small bon commande
            const lineSpacing = isSmallBonCommande ? 5 : 7;
            doc.text("• Les prix indiqués sont en Dirhams (DH) et " + (showTTCPrices ? "incluent" : "n'incluent pas") + " la TVA.", margin, currentY + lineSpacing);
            doc.text("• Le paiement doit être effectué selon les conditions convenues.", margin, currentY + (lineSpacing * 2));
            doc.text("• La livraison sera effectuée selon les modalités indiquées ci-dessus.", margin, currentY + (lineSpacing * 3));

            // Update current Y position after terms and conditions
            currentY += isSmallBonCommande ? 20 : 25;

            // Check if we need to add a new page for signature
            const signatureHeight = isSmallBonCommande ? 35 : 40;

            // Only add a new page if absolutely necessary
            const remainingSpace = pageHeight - footerHeight - currentY;
            if (remainingSpace < signatureHeight) {
                doc.addPage();
                addHeader(doc, false);
                addFooter(doc);
                currentY = 30; // Reset Y position on new page
            }

            // Add signature section
            doc.setDrawColor(200, 200, 200);
            doc.setFontSize(9);
            doc.setTextColor(80, 80, 80);
            doc.setFont('helvetica', 'bold');
            doc.text("Signature et cachet:", margin, currentY);

            // Draw signature box
            const signatureBoxHeight = isSmallBonCommande ? 20 : 25;
            doc.rect(margin, currentY + 5, 60, signatureBoxHeight, 'S');

            // Add client acceptance text
            doc.setFontSize(8);
            doc.setTextColor(100, 100, 100);
            doc.setFont('helvetica', 'italic');
            const acceptanceSpacing = isSmallBonCommande ? 6 : 7;
            doc.text("Bon pour accord", rightColumnX, currentY + 8);
            doc.text("Date: ___________________", rightColumnX, currentY + 8 + acceptanceSpacing);
            doc.text("Nom: ___________________", rightColumnX, currentY + 8 + (acceptanceSpacing * 2));

            // Add footer to the first page
            addFooter(doc);

            // Add a note about the price type at the bottom of the document
            doc.setFontSize(7);
            doc.setTextColor(100, 100, 100);
            doc.setFont('helvetica', 'italic');
            doc.text(`* Document généré avec prix ${showTTCPrices ? 'TTC' : 'HT'}`, margin, pageHeight - footerHeight - 5);

            const pdfBlob = doc.output('blob');
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl);
        });
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        if (selectedCommande) {
            setSelectedCommande(null);
        }
        let payload = {
            ...filters,
        };
        dispatch(commandeActions.list(payload));
    };

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];
    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    const clearFilters = () => {
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate)
        });
    };

    const handleBonLivraison = (commande) => {
        if (!commande.entrepotId) {
            Swal.fire({
                icon: 'warning',
                title: t('commande.noEntrepot', 'Entrepôt non défini'),
                text: t('commande.noEntrepotMessage', 'Veuillez définir un entrepôt pour cette commande avant de la convertir en bon de livraison.'),
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        Swal.fire({
            title: 'Confirmation',
            text: "Cette commande sera convertie en bon de livraison. Voulez-vous confirmer?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(commandeActions.validerCommande({
                    id: commande.id,
                    onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Validée!',
                            text: 'La commande a été convertie en bon de livraison avec succès.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        // Refresh the list
                        let payload = {
                            ...filters,
                        };
                        dispatch(commandeActions.list(payload));
                    },
                    onError: (error) => {
                        // Add error handling
                        Swal.fire({
                            icon: 'error',
                            title: 'Erreur!',
                            text: `Une erreur est survenue: ${error?.message || 'Veuillez réessayer plus tard.'}`,
                            confirmButtonColor: '#3085d6',
                        });
                    }
                }));
            }
        });
    };

    const handleUpdateCommande = (commande) => {
        setSelectedCommande(commande);
        setShowModal(true);
    }

    const debouncedSearch = useCallback(
        debounce((query) => {
            dispatch(commandeActions.list({
                ...filters,
                query: query
            }));
        }, 1500),
        [filters.query]
    );

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaCashRegister className="text-primary me-2" />
                                {t('commande.list')}
                            </h4>
                            <div className="d-flex align-items-center">
                                <Button color="primary" onClick={handleShowModal}
                                >
                                    <FaPlus className="mr-2" /> {t('commande.newCommande')}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
                                <Row className="mb-3 g-2 align-items-end">
                                    <Col lg={3} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('reglement.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value
                                                        }));
                                                        debouncedSearch(value);
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                            <Select
                                                id="clientId"
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                                onChange={(selectedOption) => {
                                                    setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null }));
                                                    setSelectedClient(selectedOption);
                                                }}
                                                placeholder={t('bonLivraison.selectClient')}
                                                isSearchable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="chantierId">
                                                {t('chantier.title', 'Chantier')}:
                                            </Label>
                                            <Select
                                                id="chantierId"
                                                options={chantierOptionsWithAll}
                                                value={chantierOptionsWithAll.find(option => option.value === filters?.chantierId) || null}
                                                onChange={(selectedOption) => setFilters(f => ({ ...f, chantierId: selectedOption ? selectedOption.value : null }))}
                                                placeholder={t('chantier.select', 'Sélectionner...')}
                                                isSearchable
                                                isClearable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                            <table className="table table-hover table-striped table-bordered">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="align-middle text-center">{t('commande.numero')}</th>
                                        <th className="align-middle text-center">{t('commande.client')}</th>
                                        <th className="align-middle text-center">{t('devis.chantier')}</th>
                                        <th className="align-middle text-center">{t('commande.devis')}</th>
                                        <th className="align-middle text-center">{t('commande.dateCreation')}</th>
                                        <th className="align-middle text-center">{t('commande.dateModification')}</th>
                                        <th className="align-middle text-center">{t('commande.dateOperation')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTTC')}</th>
                                        <th className="align-middle text-center">{t('devis.montantHT')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTVA')}</th>
                                        <th className="align-middle text-center">{t('commande.status')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((commande) => (
                                        <tr key={commande.id}>
                                            <td className="align-middle text-center">{commande.numero}</td>
                                            <td className="align-middle text-center">
                                                {commande.clientNom}
                                            </td>
                                            <td className="align-middle text-center">
                                                {commande.chantierNom || 'N/A'}
                                            </td>
                                            <td className="align-middle text-center">
                                                {commande.devisNumero || 'N/A'}
                                            </td>
                                            <td className="align-middle text-center">{commande.dateCreation}</td>
                                            <td className="align-middle text-center">{commande.updatedAt || 'N/A'}</td>
                                            <td className="align-middle text-center">{commande.dateOperation || 'N/A'}</td>
                                            <td className="align-middle text-center">{formatPrice(commande.montantTotalTTC, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(commande.montantTotalHT, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(commande.montantTotalTaxe, false)}</td>
                                            <td className="align-middle text-center">
                                                {commande.status === 'EN_ATTENTE' && (
                                                    <span className="badge bg-secondary">{t('commande.statusDraft')}</span>
                                                )}
                                                {commande.status === 'VALIDE' && (
                                                    <span className="badge bg-success">{t('commande.statusValidated')}</span>
                                                )}
                                                {commande.status === 'LIVRE' && (
                                                    <span className="badge bg-primary">{t('commande.statusDelivered')}</span>
                                                )}
                                                {commande.status === 'ANNULE' && (
                                                    <span className="badge bg-danger">{t('commande.statusCancelled')}</span>
                                                )}
                                            </td>
                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    <Button
                                                        color="secondary"
                                                        title={t('commande.downloadPdf')}
                                                        onClick={() => handleGeneratePdf(commande)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaFilePdf />
                                                    </Button>

                                                    {commande.status === 'EN_ATTENTE' && <Button
                                                        color="success"
                                                        title={t('commande.bonLivraison')}
                                                        onClick={() => handleBonLivraison(commande)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}

                                                    <Button
                                                        color="warning"
                                                        title={t('commande.edit')}
                                                        onClick={() => handleUpdateCommande(commande)}
                                                        size="sm"
                                                        className='me-1'
                                                    >
                                                        <FaEdit />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {list.length === 0 && (
                                        <tr>
                                            <td colSpan="12" className="text-center py-4">
                                                <div className="text-muted">{t('commande.noCommande')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-light fw-bold">
                                        <td colSpan="7" className="text-end">{t('common.totals')}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalHT || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTaxe || 0), 0), false)}</td>
                                        <td colSpan="2"></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </>)}
                </CardBody>
            </Card>
            <Modal isOpen={showModal} toggle={handleCloseModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseModal}>{selectedCommande ? `Commande N°: ${selectedCommande.numero}` : t('commande.newCommande')}</ModalHeader>
                <ModalBody>
                    <BCForm preloadedCompany={company} commande={selectedCommande} onClose={handleCloseModal} />
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default BonCommandeList;